import script from "./UploadFile.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadFile.vue?vue&type=script&setup=true&lang=js"

import "./UploadFile.vue?vue&type=style&index=0&id=4691f0e4&lang=scss&scoped=true"

import exportComponent from "/home/deployer/deploypad/silogues/releases/20261022152544/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4691f0e4"]])

export default __exports__